import {NotificationPreferencesConfig, UpdateNotificationPreference} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function get_(): Promise<NotificationPreferencesConfig> {
  return await platformedClient.internalRequest("get", `/api/notification_preferences`, {});
}

export async function update(preferenceConfig: UpdateNotificationPreference) {
  const res = await platformedClient.internalRequest("post", `/api/notification_preferences/update`, {
    body: preferenceConfig,
  });
  await invalidateQueries([q.notificationPreferences.filter()]);
  return res;
}

export async function bulkUpdate(updates: UpdateNotificationPreference[]) {
  const res = await platformedClient.internalRequest("post", `/api/notification_preferences/bulk-update`, {
    body: {updates},
  });
  await invalidateQueries([q.notificationPreferences.filter()]);
  return res;
}
